var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDeleteBlack = function SvgDeleteBlack(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @media (prefers-color-scheme: dark) {\n            path {\n                fill: white !important;\n            }\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,10.5 L16.5,16.5 C16.5,17.325 15.825,18 15,18 L15,18 L9,18 C8.175,18 7.5,17.325 7.5,16.5 L7.5,16.5 L7.5,10.5 L16.5,10.5 Z M14.25,6 C14.7,6 15,6.3 15,6.75 L15,6.75 L15,8.25 L18,8.25 L18,9.75 L6,9.75 L6,8.25 L9,8.25 L9,6.75 C9,6.3 9.3,6 9.75,6 L9.75,6 Z M13.5,7.5 L10.5,7.5 L10.5,8.25 L13.5,8.25 L13.5,7.5 Z",
    fill: "#1C140D",
    fillRule: "nonzero"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_black.9c483cf1.svg";
export { ForwardRef as ReactComponent };